import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import ToolsIndex from "@/pages/ToolsIndex";
import Recommender from "@/pages/tools/Recommender";
import RetirementIncome from "@/pages/tools/RetirementIncome";
import LifeInsuranceNeeds from "@/pages/tools/LifeInsuranceNeeds";
import CollegeSavings from "@/pages/tools/CollegeSavings";
import MedicareEligibility from "@/pages/tools/MedicareEligibility";
import LTCCost from "@/pages/tools/LTCCost";
import Apply from "@/pages/Apply";
import ApplySuccess from "@/pages/ApplySuccess";
import ProductDetail from "@/pages/ProductDetail";
import Strategy from "@/pages/Strategy";
import Persona from "@/pages/Persona";
import Scenarios from "@/pages/Scenarios";
import ScenarioDetail from "@/pages/ScenarioDetail";
import Process from "@/pages/Process";
import Learn from "@/pages/Learn";
import Article from "@/pages/Article";
import Compliance from "@/pages/Compliance";
import Services from "@/pages/Services";
import Service from "@/pages/Service";
import Carriers from "@/pages/Carriers";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/strategy" element={<Strategy />} />
          <Route path="/products/:slug" element={<ProductDetail />} />
          <Route path="/for/:slug" element={<Persona />} />
          <Route path="/insights/scenarios" element={<Scenarios />} />
          <Route path="/insights/scenarios/:slug" element={<ScenarioDetail />} />
          <Route path="/process" element={<Process />} />
          <Route path="/learn" element={<Learn />} />
          <Route path="/learn/:slug" element={<Article />} />
          <Route path="/compliance" element={<Compliance />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:slug" element={<Service />} />
          <Route path="/carriers" element={<Carriers />} />
          <Route path="/tools" element={<ToolsIndex />} />
          <Route path="/tools/recommender" element={<Recommender />} />
          <Route path="/tools/retirement-income" element={<RetirementIncome />} />
          <Route path="/tools/life-insurance-needs" element={<LifeInsuranceNeeds />} />
          <Route path="/tools/college-savings" element={<CollegeSavings />} />
          <Route path="/tools/medicare-eligibility" element={<MedicareEligibility />} />
          <Route path="/tools/ltc-cost" element={<LTCCost />} />
          <Route path="/apply" element={<Apply />} />
          <Route path="/apply/success" element={<ApplySuccess />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
